export function createStaticReducer<T>(initialState: T) {
  return (state: T = initialState): T => {
    return state;
  };
}
